import { registrationCategory } from "../constants/register.constants";
import {
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../shared/helpers";
import { useAuth } from "../contexts/AuthContext";

/**
 * User/roles from AuthContext (set only after AuthProvider validates session).
 * Avoids trusting localStorage for isLoggedIn; all consumers get validated state.
 */
const useRoles = () => {
  const { user } = useAuth();
  const storageData = user ?? null;

  const isPharmacy = verifyUserType(registrationCategory.PHARMACY, storageData);
  const isConnectedNurse = verifyUserType(
    registrationCategory.CONNECTED_NURSE,
    storageData
  );
  const isPrescriber = verifyUserType(
    registrationCategory.PRESCRIBER,
    storageData
  );
  const isHomecare = verifyUserType(
    registrationCategory.CONNECTED_HOMECARE,
    storageData
  );
  const isOutpatient = verifyUserType(
    registrationCategory.CONNECTED_OUTPATIENT,
    storageData
  );
  const isCustomerSolution = verifyUserType(
    registrationCategory.CUSTOMER_SOLUTION,
    storageData
  );
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR,
    storageData
  );

  const isPrimaryPharmacist = storageData?.primary_user || null;

  return {
    isConnectedNurse,
    isConnectedRegistrar,
    isPharmacy,
    isPrescriber,
    isHomecare,
    isCustomerSolution,
    isOutpatient,
    storageData,
    isPrimaryPharmacist,
  };
};

export default useRoles;
